(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rivt-product-experience"] && !Shopify.designMode) return;
  try {
    
  (()=>{
    function init(){
      if(!document.querySelector('.rivt-faq'))return;
      const main=document.querySelector('product-info');
      if(!main)return;
      const bar=document.querySelector('.rivt-mobile-bar');const button=main.querySelector('.product-form__submit');
      if(bar&&button&&!bar.dataset.ready){
        bar.dataset.ready='true';new IntersectionObserver(entries=>{bar.classList.toggle('is-visible',!entries[0].isIntersecting&&button.getBoundingClientRect().top<0);},{threshold:0}).observe(button);
        bar.querySelector('[data-rivt-choose]').addEventListener('click',()=>{const target=main.querySelector('variant-selects')||button;target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center'});const input=target.querySelector('input:not(:disabled),select')||button;input.focus({preventScroll:true});});
      }
    }
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
    document.addEventListener('shopify:section:load',init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rivt-size-finder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rivt-size-finder')) customElements.define('rivt-size-finder', class extends HTMLElement {
    connectedCallback() {
      this.dialog=this.querySelector('dialog');this.form=this.querySelector('form');this.data=JSON.parse(this.querySelector('[data-fit-product]').textContent);this.text=JSON.parse(this.querySelector('[data-fit-text]').textContent);
      const title=this.data.title.toLowerCase();this.form.elements.range.value=title.includes('women')?'women':title.includes('men')?'men':'women';
      const kind=title+' '+(this.data.type||'').toLowerCase();const category=/boot|clog|shoe|slipper|sandal|sneaker|loafer|mule|footwear/.test(kind)?'shoes':/dress|gown/.test(kind)?'dress':/\bsets?\b|tracksuit|co-ord/.test(kind)?'sets':/jacket|coat|outerwear/.test(kind)?'outerwear':/trouser|pants|jeans|shorts|skirt/.test(kind)?'bottoms':/\bbags?\b|necklace|\brings?\b|bracelet|earring|accessor/.test(kind)?'accessories':'tops';this.form.elements.category.value=category;
      if(title){this.form.elements.category.disabled=true;if(title.includes('women')||title.includes('men'))this.form.elements.range.disabled=true;}
      this.openHandler=(event)=>{if(event.target.closest('[data-fit-open]')){this.opener=event.target.closest('[data-fit-open]');if(this.data.title&&this.form.elements.range.disabled){this.prepare();}else{this.showStep(1);}this.dialog.showModal();}};document.addEventListener('click',this.openHandler);
      this.querySelector('[data-fit-close]').onclick=()=>this.dialog.close();this.dialog.addEventListener('close',()=>this.opener?.focus());
      this.querySelector('[data-fit-next]').onclick=()=>this.prepare();this.querySelector('[data-fit-back]').onclick=()=>this.showStep(1);this.querySelector('[data-fit-restart]').onclick=()=>this.showStep(1);this.querySelector('[data-fit-apply]').onclick=()=>this.apply();
      this.form.addEventListener('submit',event=>{event.preventDefault();this.calculate();});
      this.form.elements.unit.addEventListener('change',()=>{const factor=this.form.elements.unit.value==='cm'?2.54:1/2.54;['chest','waist','hip'].forEach(key=>{const field=this.form.elements[key];if(field.value)field.value=(Number(field.value)*factor).toFixed(1);});});
    }
    disconnectedCallback(){document.removeEventListener('click',this.openHandler);}
    showStep(step){this.querySelectorAll('[data-fit-step]').forEach(el=>el.hidden=Number(el.dataset.fitStep)!==step);this.querySelector('[data-fit-count]').textContent=step+' / 3';this.querySelector('.rivt-finder__progress span').style.width=(step/3*100)+'%';this.dialog.scrollTop=0;}
    prepare(){this.category=this.form.elements.category.value;this.querySelector('[data-fit-instruction]').textContent=this.text.instructions[this.category];this.querySelector('[data-fit-measure]').textContent=this.text.measure[this.category]||this.text.instructions[this.category];if(this.category==='accessories'){this.finish(this.text.accessory,this.text.instructions.accessories,null);return;}const shoes=this.category==='shoes';this.querySelector('[data-fit-clothing]').hidden=shoes;this.querySelector('[data-fit-shoes]').hidden=!shoes;['chest','waist','hip'].forEach(key=>{const visible=!shoes&&(this.category==='bottoms'?key!=='chest':['dress','sets'].includes(this.category)?true:key==='chest');this.querySelector('[data-fit-'+key+']').hidden=!visible;this.form.elements[key].required=visible;});this.form.elements.shoe.required=shoes;this.querySelector('[data-fit-error]').textContent='';this.showStep(2);}
    calculate(){
      const gender=this.form.elements.range.value;let size=null;let eu=null;
      if(this.category==='shoes'){
        const shoe=Number(this.form.elements.shoe.value);const rows=gender==='women'?[[4,34],[5,35],[6,36],[7,37],[8,38],[9,39],[10,40],[10.5,41],[11,42],[12,43],[13,44],[14,45]]:[[6,39],[7,40],[8,41],[9,42],[10,43],[11,44],[12,45],[13,46],[14,47],[15,48],[16,49]];
        if(!Number.isFinite(shoe)||shoe<rows[0][0]||shoe>rows.at(-1)[0]){this.querySelector('[data-fit-error]').textContent=this.text.outside;return;}eu=rows.find(row=>row[0]>=shoe)[1];size='US '+shoe+' / EU '+eu;
      }else{
        const labels=['XXS','XS','S','M','L','XL','XXL','3XL','4XL'];const rows=gender==='women'?{chest:[27.5,29.5,32.5,35.5,38,41,44.5,48.5],waist:[21.25,23.5,26,29,31.5,34.5,38.5,42.5],hip:[30.5,33,35.5,38.5,41,44,47,50]}:{chest:[28.1,31.5,35,37.5,41,44,48.5,53.5,58,63],waist:[22.5,25.5,29,32,35,38,43,47.5,52.5,57],hip:[28.5,31.5,35,37.5,41,44,47,50.5,53.5,58.5]};
        const keys=this.category==='bottoms'?['waist','hip']:['dress','sets'].includes(this.category)?['chest','waist','hip']:['chest'];let index=0;
        for(const key of keys){const n=Number(this.form.elements[key].value)/(this.form.elements.unit.value==='cm'?2.54:1);const limits=rows[key];if(!Number.isFinite(n)||n<limits[0]||n>limits.at(-1)){this.querySelector('[data-fit-error]').textContent=this.text.outside;return;}let i=limits.slice(1).findIndex(limit=>n<=limit);if(this.form.elements.preference.value==='relaxed'&&Math.abs(n-limits[i+1])<=0.5&&i<limits.length-2)i++;index=Math.max(index,i);}size=labels[index];
      }
      const optionIndex=(this.data.options||[]).findIndex(name=>/^(size|größe|groesse|taille)$/i.test(name));this.optionIndex=optionIndex;let match=null;
      if(optionIndex>=0){const normalize=v=>String(v).toUpperCase().replace('2XL','XXL').trim();const values=[...new Set((this.data.variants||[]).map(v=>v.options[optionIndex]))];match=values.find(value=>{const v=normalize(value);if(eu===null)return v===normalize(size);if(v.startsWith('US')){const nums=v.split('/')[0].replace('US','').trim().split(/[-–]/).map(Number);const n=Number(this.form.elements.shoe.value);return nums.length===1?n===nums[0]:n>=nums[0]&&n<=nums[1];}const nums=v.replace('EU','').trim().split(/[-–]/).map(Number);return nums.length===1?eu===nums[0]:eu>=nums[0]&&eu<=nums[1];});}
      if(match){const picker=document.querySelector('product-info variant-selects')||document.querySelector('variant-selects');const chosen=Array.from(picker?.querySelectorAll('fieldset')||[]).map(field=>field.querySelector('input:checked')?.value);if(!chosen.length)chosen.push(...Array.from(picker?.querySelectorAll('select')||[]).map(el=>el.value));const available=(this.data.variants||[]).some(variant=>variant.available&&variant.options[optionIndex]===match&&variant.options.every((v,i)=>i===optionIndex||!chosen[i]||chosen[i]===v));if(!available)match=null;}
      this.finish(size,eu===null?this.text.suggestion:this.text.shoeNote,match);
    }
    finish(size,note,match){this.match=match;this.querySelector('[data-fit-size]').textContent=size;const apply=this.querySelector('[data-fit-apply]');const hasProduct=Boolean(this.data.title);if(hasProduct&&!match&&this.category!=='accessories')note+=' '+this.text.unavailable;this.querySelector('[data-fit-result-note]').textContent=note;apply.textContent=match?this.text.apply:hasProduct?this.text.close:this.text.browse;this.showStep(3);}
    apply(){if(this.match){const picker=document.querySelector('product-info variant-selects')||document.querySelector('variant-selects');const fieldsets=picker?.querySelectorAll('fieldset');const select=picker?.querySelectorAll('select')[this.optionIndex];const input=Array.from(fieldsets?.[this.optionIndex]?.querySelectorAll('input[type="radio"]')||[]).find(el=>el.value===this.match);if(input){input.click();}else if(select){select.value=this.match;select.dispatchEvent(new Event('change',{bubbles:true}));}picker?.scrollIntoView({behavior:'smooth',block:'center'});}this.dialog.close();}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rivt-store-style"]) return;
  try {
    
  const rivtTranslateCartLabels = () => {
    document.querySelectorAll('.product-option dt').forEach(label => {
      const value = label.textContent.trim().replace(/:$/, '').toLowerCase();
      if (value === 'größe' || value === 'groesse' || value === 'taille') label.textContent = document.querySelector('[data-rivt-size-label]')?.dataset.rivtSizeLabel + ':';
      if (value === 'farbe' || value === 'colour') label.textContent = document.querySelector('[data-rivt-color-label]')?.dataset.rivtColorLabel + ':';
    });
  };
  rivtTranslateCartLabels();
  new MutationObserver(rivtTranslateCartLabels).observe(document.body, {childList:true,subtree:true});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rivt-story"] && !Shopify.designMode) return;
  try {
    
 document.addEventListener('click',event=>{const link=event.target.closest('[data-rivt-back]');if(!link)return;event.preventDefault();document.querySelector('product-info').scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});});

  } catch(e) { console.error(e); }
})();
})();
